<template>
  <b-modal
    :ref="alertRef"
    hide-footer
    hide-header-close
    hide-header
    :body-class="`rounded`"
    :no-close-on-backdrop="persistent"
    size="summary"
    @hidden="isActive = false"
    centered
  >
    <div>
      <div
        class="d-flex justify-content-between align-items-center w-100 mt-1 mb-2"
      >
        <div
          class="d-flex align-items-center Justify-content-center"
          style="gap: 7px"
        >
          <span class="title-alert font-strong">{{ title }}</span>
        </div>
        <div class="bg-close text-secondary cursor-pointer" @click="close()">
          <feather-icon icon="XIcon" size="16" variant="dark" />
        </div>
      </div>
      <div class="d-flex align-items-center mt-1">
        <div class="icon-badge mr-1 pending">
          <feather-icon
            :icon="icon"
            size="20"
            :class="colorIcons(icon)"
          ></feather-icon>
        </div>
        <span>
          <span :class="colorText" class="text-uppercase">
            <TextWrapper v-if="subtitle" :text="subtitle" />
          </span>
        </span>
      </div>
      <hr />
      <div class="d-flex flex-column" style="gap: 15px">
        <div
          class="d-flex justify-content-between"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="d-flex align-items-center justify-content-start">
            <feather-icon
              v-if="item.isFeather && item.icon"
              :icon="item.icon"
              class="mr-1 font-strong"
              :class="item.class"
              size="16"
              svgClasses="font-small-4"
              style="width: 30px"
            />
            <tabler-icon
              v-if="!item.isFeather && item.icon"
              :icon="item.icon"
              class="mr-1 font-strong"
              :class="item.class"
              size="16"
              svgClasses="font-small-4"
              style="width: 30px"
            />
            <span class="font-strong text-left">
              {{ item.title }}
            </span>
          </div>

          <span class="font-strong pl-1">
            <TextWrapper
              v-if="item.description"
              :text="item.description"
              :align="'right'"
            />
          </span>
        </div>
      </div>
      <hr v-if="data.length > 0" />
      <template v-if="hasComponent">
        <div class="grid-flow">
          <b-button
            variant="primary"
            target="_blank"
            @click.prevent="showComponent = true"
            >{{ okComponentTitle }}
          </b-button>
          <b-button variant="primary" target="_blank" @click.prevent="closeOnOK"
            >{{ okTitle }}
          </b-button>
        </div>
      </template>
      <b-button
        v-else
        class="w-100"
        variant="primary"
        target="_blank"
        @click.prevent="closeOnOK"
        >{{ okTitle }}
      </b-button>
    </div>
    <template v-if="hasComponent">
      <component
        v-if="showComponent"
        :is="dataComponent.name"
        v-bind="dataComponent.props"
        @close="
          showComponent = false;
          close();
        "
      />
    </template>
  </b-modal>
</template>
<script>
import store from "@/store";
import { mapGetters } from "vuex";
// import ModalDetails from "@/views/commons/components/helpdesk/components/modals/ModalDetailsKanban.vue";
import TextWrapper from "@/views/commons/utilities/TextWrapper.vue";
export default {
  name: "AlertClaimEmployee",
  components: {
    TextWrapper,
    // ModalDetails,
  },
  data() {
    return {
      showComponent: false,
    };
  },
  mounted() {
    this.toggleModal(this.alertRef);
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    ok: {
      type: Function,
      default: () => {},
    },
    okTitle: {
      type: String,
      default: "OK",
    },
    okComponentTitle: {
      type: String,
      default: "OK",
    },
    alertRef: {
      type: String,
      default: "amg-alert",
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    dataComponent: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    colorText() {
      const status = this.dataClaim?.status;
      let color = {
        COMPLETED: "text-success font-strong",
        REACTIVATED: "text-warning font-strong",
        PENDING: "text-warning font-strong",
        SCALED: "text-warning font-strong",
      };
      return color[status];
    },
    hasComponent() {
      return !!this.dataComponent;
    },
  },
  methods: {
    createComponent() {
      return resolveComponent(this.dataComponent.name);
    },
    close() {
      this.$refs[this.alertRef].hide();
    },
    colorIcons(icon) {
      const color = {
        BookOpenIcon: "text-warning",
        AlertCircleIcon: "text-warning",
        CheckCircleIcon: "text-success",
        CheckIcon: "text-success",
        InfoIcon: "text-info",
        XIcon: "text-danger",
      };
      return color[icon] || "text-warning";
    },
    closeOnOK() {
      this.ok();
      this.close();
    },
  },
  watch: {
    showComponent(val) {
      store.commit("StandarStore/SET_SHOW_AMG_ALERT", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-badge {
  padding: 0.5rem 0.7rem;
  background-color: #ececec;
  border-radius: 0.25rem;
  &.completed {
    background-color: rgba(40, 199, 111, 0.1);
    color: #ff9f43;
  }
  &.pending {
    background-color: rgba(255, 159, 67, 0.1);
    color: #ff9f43;
  }
  &.reactivated {
    background-color: rgba(255, 159, 67, 0.1);
    color: #ff9f43;
  }
  &.scaled {
    background-color: rgba(255, 159, 67, 0.1);
    color: #ff9f43;
  }
}

.close-modal {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.5rem 0.7rem;
  background-color: #ececec;
  border-radius: 0.25rem;
  &:hover {
    background-color: #585858;
    color: #ececec;
    cursor: pointer;
  }
}

.title-alert {
  font-size: 1.2rem;
}

.bg-close {
  color: #ececec;
  .dark {
    background-color: #585858;
  }
}
.grid-flow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
}
</style>
